"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageNames = exports.FormV2 = void 0;
var _react = _interopRequireWildcard(require("react"));
var _socialLogin = require("./socialLogin");
var _useLogin2 = require("./useLogin");
require("./styles.scss");
var _Box = _interopRequireDefault(require("schoolUiComponents/basic/Box"));
var _Button = _interopRequireDefault(require("schoolUiComponents/basic/Button"));
var _Text = _interopRequireDefault(require("schoolUiComponents/basic/Text"));
var _FlexBox = _interopRequireDefault(require("schoolUiComponents/basic/Box/FlexBox"));
var _Input = _interopRequireDefault(require("schoolUiComponents/basic/Input"));
var _colors = require("baseStyles/enums/colors");
var _types = require("schoolUiComponents/basic/Box/FlexBox/types");
var _types2 = require("schoolUiComponents/basic/Input/types");
var _passwordIcon = _interopRequireDefault(require("./assets/passwordIcon.svg"));
var _passwordShowIcon = _interopRequireDefault(require("./assets/passwordShowIcon.svg"));
var _style = _interopRequireDefault(require("./style"));
var _events = require("../../ptlSignup/events");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var PageNames; // @ts-ignore
exports.PageNames = PageNames;
(function (PageNames) {
  PageNames["PTL_LOGIN"] = "ptlParentLoginScreen";
  PageNames["PTL_OTP_LOGIN"] = "loginViaOtpByClassroomLinkedParent";
})(PageNames || (exports.PageNames = PageNames = {}));
window.ptlLoginEventProps = {
  pageName: PageNames.PTL_LOGIN,
  otpEntered: false
};
var FormV2 = function FormV2(_ref) {
  var _ref$showOTPLoginOpti = _ref.showOTPLoginOption,
    showOTPLoginOption = _ref$showOTPLoginOpti === void 0 ? true : _ref$showOTPLoginOpti,
    _ref$primaryInputLabe = _ref.primaryInputLabel,
    primaryInputLabel = _ref$primaryInputLabe === void 0 ? "Email" : _ref$primaryInputLabe,
    _ref$showForgotPasswo = _ref.showForgotPassword,
    showForgotPassword = _ref$showForgotPasswo === void 0 ? true : _ref$showForgotPasswo,
    _ref$showSocialLogin = _ref.showSocialLogin,
    showSocialLogin = _ref$showSocialLogin === void 0 ? true : _ref$showSocialLogin,
    _ref$source = _ref.source,
    source = _ref$source === void 0 ? null : _ref$source,
    _ref$sendEvent = _ref.sendEvent,
    sendEvent = _ref$sendEvent === void 0 ? function (clickedOn) {} : _ref$sendEvent;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    passwordVisibility = _useState2[0],
    togglePasswordVisibility = _useState2[1];
  var _useLogin = (0, _useLogin2.useLogin)({
      primaryInputLabel: primaryInputLabel,
      showSocialLogin: showSocialLogin,
      sendEvent: sendEvent,
      source: source,
      isPtlFlow: true
    }),
    handleLogin = _useLogin.handleLogin,
    otpSent = _useLogin.otpSent,
    setOTPSent = _useLogin.setOTPSent,
    setIntentId = _useLogin.setIntentId,
    email = _useLogin.email,
    setEmail = _useLogin.setEmail,
    error = _useLogin.error,
    setError = _useLogin.setError,
    otpLogin = _useLogin.otpLogin,
    password = _useLogin.password,
    setPassword = _useLogin.setPassword,
    timer = _useLogin.timer,
    sendOTP = _useLogin.sendOTP,
    otp = _useLogin.otp,
    setOTP = _useLogin.setOTP,
    showResendSuccessMsg = _useLogin.showResendSuccessMsg,
    setOTPLogin = _useLogin.setOTPLogin,
    socialLoginEnabled = _useLogin.socialLoginEnabled,
    maskedEmail = _useLogin.maskedEmail,
    params = _useLogin.params,
    emailEvents = _useLogin.emailEvents,
    setEmailEvents = _useLogin.setEmailEvents,
    passwordEvents = _useLogin.passwordEvents,
    setPasswordEvents = _useLogin.setPasswordEvents,
    setFromPage = _useLogin.setFromPage,
    referralData = _useLogin.referralData;
  var styles = (0, _style["default"])();
  return /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleLogin,
    autoComplete: "on",
    style: {
      backgroundColor: _colors.Colors.WHITE
    },
    "data-sentry-component": "FormV2",
    "data-sentry-source-file": "formV2.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "login-form-v2"
  }, /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
    width: styles.mainBox.width,
    gap: 17,
    alignStart: true,
    column: true,
    "data-sentry-element": "FlexBox",
    "data-sentry-source-file": "formV2.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    fullWidth: true,
    "data-sentry-element": "Box",
    "data-sentry-source-file": "formV2.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    value: email,
    placeholder: primaryInputLabel,
    autoFocus: true,
    tabIndex: 1,
    disabled: otpSent || maskedEmail,
    onChange: function onChange(e) {
      if (!(otpSent || maskedEmail)) {
        var _e$target;
        error && setError(null);
        setEmail((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
        if (!emailEvents.pasted && !emailEvents.typed) {
          setEmailEvents(_objectSpread(_objectSpread({}, emailEvents), {}, {
            typed: true
          }));
          (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
            clickedOn: "Email input box",
            interactionDetails: "Started typing"
          }, referralData));
        }
      }
    },
    name: "sl-user-login-email",
    "data-test-id": "user-login",
    color: !(email !== null && email !== void 0 && email.length) || maskedEmail || otpSent ? _colors.Colors.CONTENT_TEXT_TERTIARY : _colors.Colors.DARK_GREY,
    hasError: error,
    width: styles.mainBox.width,
    padding: "16px 24px",
    customPlaceholder: true,
    fontSize: 16,
    lineHeight: 24,
    fontWeight: 600,
    onClick: function onClick() {
      return (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
        clickedOn: "Email input box",
        interactionDetails: ""
      }, referralData));
    },
    onPaste: function onPaste() {
      setEmailEvents(_objectSpread(_objectSpread({}, emailEvents), {}, {
        pasted: true
      }));
      (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
        clickedOn: "Email input box",
        interactionDetails: "Copy pasted"
      }, referralData));
    },
    "data-sentry-element": "Input",
    "data-sentry-source-file": "formV2.tsx"
  }), maskedEmail && !(params !== null && params !== void 0 && params.user_id) && /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
    justifyContent: _types.FlexProps.JustifyContent.FLEX_END,
    padding: "0 24px",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    onClick: function onClick() {
      if (maskedEmail) {
        var searchParams = new URLSearchParams();
        Object.keys(params || {}).forEach(function (key) {
          return searchParams.append(key, params === null || params === void 0 ? void 0 : params[key]);
        });
        window.location.href = "/ptl-setup?".concat(searchParams);
      }
      sendEvent("Change email");
      (0, _events.interactedLoginViaOtpByClassroomLinkedParentEvent)(_objectSpread({
        clickedOn: "Change email",
        interactionDetails: "",
        otpEntered: (otp === null || otp === void 0 ? void 0 : otp.length) === 6
      }, referralData));
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].NORMAL, {
    emphasis: true,
    noUnderline: true,
    cta: true
  }, "Change email"))), otpLogin && !otpSent && error && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    padding: "0 24px",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].SMALL, {
    color: _colors.Colors.DARK_RED_2,
    fullWidth: true,
    lines: 3
  }, error))), !otpLogin && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    value: password,
    type: passwordVisibility ? _types2.InputTypes.TEXT : _types2.InputTypes.PASSWORD,
    placeholder: "Password",
    tabIndex: 2,
    onChange: function onChange(e) {
      var _e$target2;
      error && setError(null);
      if (!passwordEvents.pasted && !passwordEvents.typed) {
        setPasswordEvents(_objectSpread(_objectSpread({}, passwordEvents), {}, {
          typed: true
        }));
        (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
          clickedOn: "Password input box",
          interactionDetails: "Started typing"
        }, referralData));
      }
      setPassword((_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value);
    },
    name: "sl-user-login-password",
    "data-test-id": "user-password",
    color: !(password !== null && password !== void 0 && password.length) ? _colors.Colors.CONTENT_TEXT_TERTIARY : _colors.Colors.DARK_GREY,
    hasError: error,
    width: styles.mainBox.width,
    padding: "16px 24px",
    customPlaceholder: true,
    icon: /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
      height: 24,
      onClick: function onClick() {
        return togglePasswordVisibility(function (visible) {
          return !visible;
        });
      }
    }, passwordVisibility ? /*#__PURE__*/_react["default"].createElement(_passwordShowIcon["default"], null) : /*#__PURE__*/_react["default"].createElement(_passwordIcon["default"], null)),
    fontSize: 16,
    lineHeight: 24,
    fontWeight: 600,
    onClick: function onClick() {
      return (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
        clickedOn: "Password input box",
        interactionDetails: ""
      }, referralData));
    },
    onPaste: function onPaste() {
      setPasswordEvents(_objectSpread(_objectSpread({}, passwordEvents), {}, {
        pasted: true
      }));
      (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
        clickedOn: "Password input box",
        interactionDetails: "Copy pasted"
      }, referralData));
    }
  }), showForgotPassword && /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
    tabIndex: 4,
    justifyContent: _types.FlexProps.JustifyContent.FLEX_END,
    padding: "0 24px",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    onClick: function onClick() {
      (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
        clickedOn: "Forgot Password",
        interactionDetails: ""
      }, referralData));
      window.open("/forgot_password", "_system");
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].NORMAL, {
    emphasis: true,
    noUnderline: true,
    cta: true
  }, "Forgot password?"))), error && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    padding: "0 24px",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].SMALL, {
    color: _colors.Colors.DARK_RED_2,
    fullWidth: true,
    lines: 3
  }, error))), otpLogin && otpSent && /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
    gap: 8,
    fullWidth: true,
    column: true,
    alignStart: true
  }, otpLogin && otpSent && /*#__PURE__*/_react["default"].createElement(_Text["default"].SMALL, {
    color: _colors.Colors.CONTENT_TEXT_SECONDARY
  }, "We\u2019ve sent a verification code to the email above."), /*#__PURE__*/_react["default"].createElement("div", {
    className: "otp-text"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    className: "otp",
    maxLength: 6,
    autoComplete: "off",
    onChange: function onChange(_ref2) {
      var _target$value;
      var target = _ref2.target;
      error && setError(null);
      setOTP(target === null || target === void 0 ? void 0 : target.value);
      // @ts-ignore
      window.ptlLoginEventProps.otpEntered = (target === null || target === void 0 ? void 0 : (_target$value = target.value) === null || _target$value === void 0 ? void 0 : _target$value.length) === 6;
    },
    autoFocus: true,
    value: otp,
    "data-test-id": "otp-input",
    onClick: function onClick() {
      return (0, _events.interactedLoginViaOtpByClassroomLinkedParentEvent)(_objectSpread({
        clickedOn: "OTP input",
        interactionDetails: "",
        otpEntered: (otp === null || otp === void 0 ? void 0 : otp.length) === 6
      }, referralData));
    }
  }), /*#__PURE__*/_react["default"].createElement("input", {
    className: "autocomplete",
    type: "email",
    readOnly: true
  }), ["", "", "", "", "", ""].map(function (_char, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "otp-box"
    }, (otp === null || otp === void 0 ? void 0 : otp[index]) || "");
  })), otpSent && /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
    className: "".concat(timer ? "disabled otp-timer" : ""),
    onClick: timer > 0 ? null : function () {
      return sendOTP();
    },
    justifyContent: _types.FlexProps.JustifyContent.FLEX_END,
    padding: "0 24px",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].NORMAL, {
    emphasis: true,
    opacity: timer > 0 ? 0.4 : 1,
    noUnderline: true,
    cta: true
  }, "Resend code ", timer ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, " ", "in ", /*#__PURE__*/_react["default"].createElement("strong", null, timer, "s")) : "")), error && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    padding: "0 24px",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].SMALL, {
    color: _colors.Colors.DARK_RED_2,
    fullWidth: true,
    lines: 3
  }, error)), showResendSuccessMsg && /*#__PURE__*/_react["default"].createElement("p", {
    className: "info success"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "iconcust-iconCheck"
  }), " A new verification code has been sent.")), /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
    gap: 16,
    column: true,
    fullWidth: true,
    "data-sentry-element": "FlexBox",
    "data-sentry-source-file": "formV2.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    primary: true,
    onClick: handleLogin,
    "data-test-id": "login-submit-button",
    tabIndex: 3,
    disabled: !(email !== null && email !== void 0 && email.length),
    "data-sentry-element": "Button",
    "data-sentry-source-file": "formV2.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].H4, {
    color: _colors.Colors.WHITE,
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "formV2.tsx"
  }, otpLogin ? "Submit" : "Log in")), showOTPLoginOption && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    bordered: true,
    onClick: function onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      setOTPLogin(function (value) {
        return !value;
      });
      setError(null);
      if (otpLogin) {
        // @ts-ignore
        window.ptlLoginEventProps.pageName = PageNames.PTL_OTP_LOGIN;
        setFromPage("Parent login via otp verification screen");
        (0, _events.interactedLoginViaOtpByClassroomLinkedParentEvent)(_objectSpread({
          clickedOn: "Login with password",
          interactionDetails: "",
          otpEntered: (otp === null || otp === void 0 ? void 0 : otp.length) === 6
        }, referralData));
      } else {
        // @ts-ignore
        window.ptlLoginEventProps.pageName = PageNames.PTL_LOGIN;
        setFromPage("Parent login screen");
        (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
          clickedOn: "Log in via verification code",
          interactionDetails: ""
        }, referralData));
      }
    },
    "data-test-id": "verification-code-hypertext"
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].H4, {
    color: _colors.Colors.PURE_PURPLE,
    hoverColor: _colors.Colors.NAVY_BLUE
  }, "Login via ", otpLogin ? "password" : "verification code"))), otpLogin && otpSent && /*#__PURE__*/_react["default"].createElement(_Text["default"].SMALL, {
    fullWidth: true,
    lines: 3,
    color: _colors.Colors.CONTENT_TEXT_TERTIARY
  }, "If you are not seeing the email, the email may have landed in your spam folder, or your account may be associated with a different email.")), socialLoginEnabled && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "or-bar"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "or-bar-text"
  }, "or Login with")), /*#__PURE__*/_react["default"].createElement(_socialLogin.SocialLogin, null))));
};
exports.FormV2 = FormV2;